import { AlertColor } from '@mui/material';
import {
  hideSnackBar,
  setLoadingText as setLoadingTextAction,
  setProgress,
  showSnackBar,
  startLoading,
  stopLoading
} from 'src/api/ui-slice';
import { store } from 'src/app/store';

function snack(text: string, severity: AlertColor): void {
  store.dispatch(showSnackBar({ text: (text ?? '').replace(/<[^>]+>/g, ''), severity }));
}

export function snackInfo(text: string): void {
  snack(text, 'info');
}

export function snackSuccess(text: string): void {
  snack(text, 'success');
}

export function snackWarning(text: string): void {
  snack(text, 'warning');
}

export function snackError(text: string): void {
  snack(text, 'error');
}

export function hideSnack(): void {
  store.dispatch(hideSnackBar());
}

export function showLoadingOverlay(type: 'simple' | 'progress' = 'simple'): void {
  store.dispatch(startLoading(type));
  if (type === 'progress') {
    store.dispatch(setProgress(0));
  }
}

export function setLoadingProgress(percent: number): void {
  store.dispatch(setProgress(percent));
}

export function setLoadingText(text: string | null): void {
  store.dispatch(setLoadingTextAction(text));
}

export function hideLoadingOverlay(): void {
  store.dispatch(stopLoading());
}